import { render, staticRenderFns } from "./kapor-form.vue?vue&type=template&id=7ea35222&lang=pug"
import script from "./kapor-form.vue?vue&type=script&lang=js"
export * from "./kapor-form.vue?vue&type=script&lang=js"
import style0 from "@ui-common/vue-spinner/dist/vue-spinner.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports